module.exports = __webpack_public_path__ + "static/media/lightbulb.1c00d66e.svg";